module.exports = __webpack_public_path__ + "../resources/img/ic_re_thumbsup_spark.56264092.svg";